import { useRouteError } from 'react-router';

import { ErrorBoundary } from '../components/ErrorBoundary';

export const RouterError = () => {
  const err = useRouteError();
  return <ErrorBoundary error={err} />;
};
